export default __webpack_public_path__ + "static/media/live_chat.11d83fea.svg";